import { default as ZipPlusNewMMPDialog } from './ZipPlusNewMMPDialog';

export default ZipPlusNewMMPDialog;
